export default {
  messageBlocked: "Message was blocked by the system",
  outboundCustomerLabel: "Sent to customer",
  customerActionCancel: "Cancel",
  customerActionReceipt: "Receipt",
  messageSent: "Message sent!",
  agreementReached: "✅ Booking confirmed!",
  sendMessageError: "Failed to send message",
  cancelConfirm: "Are you sure you want to cancel this conversation?",
  conversationCancelled: "Conversation cancelled",
  cancelConversationError: "Failed to cancel conversation",
  cancelReasonAdmin: "Cancelled by staff",
  cancelReasonPartner: "Cancelled by seller",
  reopenSession: "Reopen handshake",
  reopenSessionBusy: "Reopening…",
  reopenSessionSuccess: "Handshake reopened",
  reopenSessionError: "Failed to reopen handshake",
  reopenSessionConfirmTitle: "Reopen handshake?",
  reopenSessionConfirmMessage:
    "This returns the booking to negotiation so date and time can be changed in chat with the customer.",
  reopenSessionConfirm: "Reopen handshake",
  loadingAudit: "Loading audit data...",
  replyPlaceholder: "Reply to the customer...",
  adminReplyPlaceholder: "Reply as partner to the customer...",
  conversationNotFound: "Conversation not found",
  bookingDetails: {
    title: "Booking details",
    service: "Booked service",
    activity: "Activity",
    partyHeading: "Party size",
    visitHeading: "Requested date & time",
    visitFull: "({{datetime}})",
    visitNotSet: "No date/time yet — agree in chat",
    visitOpenShort: "Date to agree in chat",
    visitScheduledMissingShort: "No date on booking",
    quantityUnknown: "Not specified",
    notes: "Customer notes",
    partyGuests_one: "{{count}} guest",
    partyGuests_other: "{{count}} guests",
    partyQuantity_one: "{{count}} unit",
    partyQuantity_other: "{{count}} units",
  },
  started: "Started {{date}}",
  conversationEmpty: "No messages yet. Reply to start the conversation.",
  agreementReadOnly:
    "This handshake is complete. The booking has been confirmed on Flitrip.",
  confirmBooking: "Confirm booking",
  confirmBookingHint:
    "Use this once you and the customer have settled the details in chat. Set the experience date and time, then confirm on Flitrip.",
  confirmVisitDateLabel: "Experience date",
  confirmVisitTimeLabel: "Time",
  confirmVisitRequired: "Enter the experience date and time.",
  confirmVisitMustBeFuture:
    "The experience date and time must be in the future. Choose a later slot if you need to correct the booking.",
  confirmSlotRequired: "Select a time slot or enter a custom time.",
  confirmSlotsLabel: "Time slots",
  confirmSlotsLoading: "Loading slots…",
  confirmSlotsError: "Could not load time slots for this day.",
  confirmDayClosed: "This day is closed on the schedule.",
  confirmNoSlots: "No time slots are configured for this day.",
  confirmSlotSpotsRemaining: "{{count}} spot(s) left",
  confirmSlotInsufficient:
    "Only {{remaining}} spot(s) left for {{partySize}} — you can still confirm",
  confirmSlotFull: "Full — you can still confirm",
  confirmSlotUnlimited: "Available",
  confirmSlotRequested: "Requested",
  confirmCustomTimeLabel: "Custom time",
  confirmCustomTimeHint:
    "Use when you agreed on a time that is not in the list. This does not use slot capacity.",
  confirmVisitPrefillHint:
    "Pre-filled from the customer request — change it if you agreed on a different slot in chat.",
  confirmBookingSuccess: "Booking confirmed on Flitrip.",
  confirmBookingError: "Could not confirm this handshake.",
  acceptBooking: "Accept",
  acceptBookingBusy: "Accepting…",
  acceptBookingHint:
    "Confirm the booking on Flitrip after you and the customer have agreed on the date and time in chat.",
  rejectBooking: "Reject",
  rejectBookingBusy: "Rejecting…",
  rejectBookingHint:
    "Decline this request. The customer will be notified and the booking will not go ahead.",
  rejectSessionTitle: "Reject this booking?",
  rejectSessionConfirm:
    "The customer will be notified that their request was declined.",
  rejectSessionAction: "Reject",
  confirmOverCapacityTitle: "Exceed slot capacity?",
  confirmOverCapacityMessage:
    "This slot allows up to {{maxCapacity}} seats. {{bookedCount}} are already confirmed and only {{availableSpots}} spot(s) remain, but this booking is for {{partySize}}. You can still confirm if you want to accept it.",
  confirmOverCapacityConfirm: "Confirm anyway",
  conversationExpired: "This conversation is expired",
  conversationCancelledStatus: "This conversation is cancelled",
  backToDashboard: "Back to Dashboard",
  sessionIdShort: "Session ID",
  cancelSession: "Cancel Session",
  updated: "Updated",
  closed: "Closed",
  references: "References",
  bookingId: "Booking ID",
  sellerId: "Seller ID",
  auditTrail: "Audit Trail ({{count}} messages)",
  blockedCount: "Blocked: {{count}}",
  noMessages: "No messages in this conversation yet.",
  list: {
    quickStatusLabel: "Filter by status",
    quickStatusAll: "All",
    adminTitle: "Handshake Dashboard",
    adminDescription: "Audit and monitor all customer-seller conversations",
    conversationsFound_one: "{{count}} conversation found",
    conversationsFound_other: "{{count}} conversations found",
    loadingConversations: "Loading conversations...",
    noConversationsFound: "No conversations found",
    tryAdjustingFilters: "Try adjusting your filters",
    emptyHintAdmin: "No handshake conversations yet",
    clearFilters: "Clear filters",
    loadFailedTitle: "Could not load conversations",
    loadFailedHint: "Check your connection and try again.",
    loadFailedRetry: "Try again",
    loadFailedStale:
      "Could not refresh the list. Showing the last loaded conversations.",
  },
} as const;
